import { AsyncPipe, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { PictureComponent } from './components/picture.component';

@NgModule({
    declarations: [PictureComponent],
    imports: [
        AsyncPipe,
        NgClass,
    ],
    exports: [PictureComponent],
})
export class UiPictureModule {
}
